import React, { useEffect, useState } from 'react';
import { GetAllOpenAuction } from '../../../hooks/AuctionHook';
import { getDataFromURI } from '../../../hooks/Tokenhook';
import { getUserByAddress } from '../../../hooks/User';
import AuctionDynamicNFTCard from './AuctionDynamicCard';
import Pagination from '../../Pagination';
import NFTCardPlaceholder from '../NFTCardPlaceholder';

const AuctionsProfileOpen = (props) => {
  const [auctions, setAuctions] = useState([]);
  const walletAddress = localStorage.getItem("WalletAddress");
  const [isPagination, setIsPagination] = useState(true);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(8); // Items per page
  const [hasMore, setHasMore] = useState(true); // Flag for infinite scroll

  useEffect(() => {
    if (props.checkLoader === false) {
      props.setCheckLoader(true);
    }

    GetAllOpenAuction().then(async (data) => {
      console.log("data", data);

      if (data.status === 201) {
        const Arr = data.data;
        const UpdatedArr = await Promise.all(
          Arr.map(async (value) => {
            const res = await getDataFromURI(value.tokenURI);
            const Seller = await getUserByAddress(value.sellerAddress).then((value) => {
              const Data = value.user;
              return Data;
            });

            if (res.status === 200) {
              const dataOfURI = res.data;
              const myDate = new Date(value.endTime * 1000);
              return {
                ...value,
                title: dataOfURI.title,
                image: dataOfURI.image,
                type: dataOfURI.type,
                category: dataOfURI.category,
                desc: dataOfURI.desc,
                endTime: myDate.toLocaleString(),
                creatorprofilePicture: Seller ? Seller.profilePicture : '',
                creatorName: Seller ? Seller.name : '---',
              };
            }
          })
        );
        setTimeout(() => {
          const filteredArr = UpdatedArr.filter((value)=> value.sellerAddress=== walletAddress)
          const reversedArr = filteredArr.reverse();

          setAuctions(reversedArr);
          setHasMore(false)
          setPageCount(Math.ceil(reversedArr.length / limit)); // Calculate total pages
        }, 3000);
        if (Arr.length === 0) {
          setIsPagination(false)
        }
      }
      else {
        setHasMore(false)
        setIsPagination(false);
      }
    });
  }, []);

  // Update displayed items based on current page

  const handlePageChange = (selectedItem) => {
    setCurrentPage(selectedItem.selected);
   
  };

  return (
    <div className="row">
      {auctions.length !== 0 ? auctions.map((val, i) => (
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 card-hover-effect" key={i}>
          <AuctionDynamicNFTCard
            NFTLink={`/auction/details/${val.contractAddress}/${val.auctionId}`}
            creatorProfile={val.creatorprofilePicture}
            creatorName={val.creatorName}
            creatorLink={val.sellerAddress === walletAddress ? "/profile " : `/otherProfile/${val.sellerAddress}`}
            mediaUrl={val.image} // Can be an image or video URL
            assetType={val.type} // Pass true for video or false for image
            title={val.title}
            price={val.price}
            likes={val.totalLikes}
            isLiked={val.isLike}
            tokenId={val.tokenId}
            endTime={val.endTime}
          />
        </div>
      )) : (hasMore ?
        // Display skeleton loader while fetching data
        <>
          {[...Array(limit)].map((_, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
              {/* <Skeleton height={300} /> */}
              <NFTCardPlaceholder />
            </div>
          ))}
        </> :
        <h3>
          No NFT Available
        </h3>
      )}
      {isPagination &&
        <Pagination
          pageCount={pageCount}
          onPageChange={handlePageChange}
          currentPage={currentPage}
        />
      }
    </div>
  );
};

export default AuctionsProfileOpen;

